import {
  Component,
  Input,
  Output,
  OnDestroy,
  OnInit,
  Renderer2,
  EventEmitter
} from '@angular/core';

import { ComponentRendering, Field } from '@sitecore-jss/sitecore-jss-angular';

import {
  FormFieldsGeneratorService,
  FormFields
} from './../../../shared/services/form-fields-generator.service';

import { LoginService } from './../../services/login.service';
import { QrCodeService } from './../../services/qr-code.service';
import { StatusService } from './../../services/status.service';
import { AB_DASHBOARD_URL } from './../../../shared/constants';
import { GetItemListFieldsService } from './../../../shared/services/get-item-list-fields.service';
import { Item } from '@sitecore-jss/sitecore-jss/types/layout';
import { NavigationStart, Router, RouterEvent } from '@angular/router';
import { Subscription, filter, interval, switchMap } from 'rxjs';
import { InitialViewService } from './../../../shared/services/initial-view.service';
import { IdleService } from './../../../session/services/idle.service';
import { AccountDetailsService } from './../../../shared/services/account-details.service';
import { UserAgentService } from './../../../shared/services/user-agent.service';

@Component({
  selector: 'ab-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnInit, OnDestroy {
  @Input() rendering: ComponentRendering;
  @Output() loginWithToken: EventEmitter<any> = new EventEmitter();

  public items: { [key: string]: Item };
  public formFields: FormFields;
  public apiError = false;
  public isLoading = false;
  public routerSubscription: Subscription;
  public isDesktop: boolean;
  public loginWith: { [key: string]: { [name: string]: Field } };
  public helpSteps: Item;
  public pageTitle: Field;
  public description: Field;
  public qrCodeImage: string;
  public loginRequestId: string;
  private statusSubscription: Subscription;
  private qrCodeSubscription: Subscription;
  public retryQR: boolean = false;

  constructor(
    protected router: Router,
    private formFieldsGeneratorService: FormFieldsGeneratorService,
    private qrCodeService: QrCodeService,
    private statusService: StatusService,
    private getItemListFieldsService: GetItemListFieldsService,
    private accountDetailsService: AccountDetailsService,
    private initialViewService: InitialViewService,
    private idleService: IdleService,
    private userAgentService: UserAgentService,
    private renderer: Renderer2
  ) {}

  ngOnInit() {
    this.idleService.stopRefreshToken();
    this.isDesktop = this.userAgentService.isDesktopDevice();
    this.formFields = this.formFieldsGeneratorService.generateFormFields(
      this.rendering
    ) as FormFields;

    if (
      this.rendering.fields.items &&
      (<Item[]>this.rendering.fields.items).length !== 0
    ) {
      this.items = this.getItemListFieldsService.getItems(
        this.rendering.fields.items as Item[]
      );
      this.loginWith = this.getItemListFieldsService.getFields(
        (this.rendering.fields.items as Item[]).filter(
          (o) => o.name === 'LoginWith'
        )[0]
      );
    }

    this.getQRCode();
  }

  getQRCode(): void {
    this.isLoading = true;
    this.qrCodeSubscription = this.qrCodeService
      .getQrCode()
      .subscribe((qrcodeImageResponse) => {
        if (this.retryQR) this.retryQR = false;
        this.isLoading = false;
        this.qrCodeImage =
          'data:image/jpeg;base64,' + qrcodeImageResponse.imageBytes;
        this.loginRequestId = qrcodeImageResponse.loginRequestId;
        this.pollLoginStatus();
      });
  }

  pollLoginStatus(): void {
    const statusObservable$ = interval(5000).pipe(
      switchMap(() => this.statusService.getStatus(this.loginRequestId))
    );

    this.statusSubscription = statusObservable$.subscribe({
      next: (status) => {
        if (status) {
          this.idleService.doRefreshToken();
          this.accountDetailsService.setFromLogin();

          this.isLoading = true;

          this.statusSubscription.unsubscribe();

          this.routerSubscription = this.router.events
            .pipe(
              filter((event: RouterEvent) => event instanceof NavigationStart)
            )
            .subscribe(() => {
              this.initialViewService.getInitialView().subscribe(() => {});
            });
          this.router.navigate([AB_DASHBOARD_URL]);
        }
      },
      error: (error) => {
        this.retryQR = true;
        this.isLoading = false;
      }
    });
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
    if (this.statusSubscription) {
      this.statusSubscription.unsubscribe();
    }
  }
}
